import React, { useEffect, useState } from "react";
import { db, storage } from "../../../firebase";
import {
  doc,
  getDoc,
  setDoc,
} from "firebase/firestore";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import "./admin.css";

interface PressRelease {
  id: string;
  title: string;
  content: string;
  date: string;
  image_url?: string;
}

export const AdminPressPage = () => {
  const [headerImage, setHeaderImage] = useState("");
  const [headerFile, setHeaderFile] = useState<File | null>(null);
  const [pressReleases, setPressReleases] = useState<PressRelease[]>([]);
  const [newPress, setNewPress] = useState<Partial<PressRelease>>({});
  const [newImageFile, setNewImageFile] = useState<File | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      const docRef = doc(db, "site_content", "press_page");
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        const data = snap.data();
        setHeaderImage(data.header_image || "");
        setPressReleases(data.press_releases || []);
      }
    };
    fetchData();
  }, []);

  const handleHeaderUpload = async () => {
    if (!headerFile) return;
    const storageRef = ref(storage, `press/header_${Date.now()}`);
    const uploadTask = uploadBytesResumable(storageRef, headerFile);

    uploadTask.on("state_changed", undefined, console.error, async () => {
      const url = await getDownloadURL(uploadTask.snapshot.ref);
      setHeaderImage(url);
    });
  };

  const uploadPressImage = async (slug: string, file: File): Promise<string> => {
    const storageRef = ref(storage, `press/images/${slug}_${Date.now()}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    return new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        undefined,
        reject,
        async () => {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(url);
        }
      );
    });
  };

  const addPressRelease = async () => {
    if (!newPress.title || !newPress.content || !newPress.date) return;

    const slug = newPress.title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");

    let imageUrl: string | undefined = undefined;
    if (newImageFile) {
      imageUrl = await uploadPressImage(slug, newImageFile);
    }

    const newItem: PressRelease = {
      id: slug + "-" + uuidv4().slice(0, 6),
      title: newPress.title,
      content: newPress.content,
      date: newPress.date,
      image_url: imageUrl,
    };

    setPressReleases((prev) => [...prev, newItem]);
    setNewPress({});
    setNewImageFile(null);
  };

  const deletePressRelease = (id: string) => {
    setPressReleases((prev) => prev.filter((p) => p.id !== id));
  };

  const saveAll = async () => {
    await setDoc(doc(db, "site_content", "press_page"), {
      header_image: headerImage,
      press_releases: pressReleases,
    });
    alert("Comunicatele au fost salvate cu succes!");
  };

  return (
    <div className="admin-container">
      <h1>Administrare Comunicate de Presă</h1>

      <label>Imagine Banner:</label>
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setHeaderFile(e.target.files?.[0] || null)}
      />
      <button onClick={handleHeaderUpload}>Încarcă imagine</button>
      {headerImage && <img src={headerImage} alt="Header" className="preview-img" />}

      <h2>Comunicate existente</h2>
      {pressReleases.map((press) => (
        <div key={press.id} className="press-item">
          <strong>{press.title}</strong>
          <p>{new Date(press.date).toLocaleDateString("ro-RO")}</p>
          {press.image_url && (
            <img src={press.image_url} alt="Preview" className="press-preview-img" />
          )}
          <button onClick={() => deletePressRelease(press.id)}>Șterge</button>
        </div>
      ))}

      <hr />

      <h2>Adaugă comunicat nou</h2>
      <input
        type="text"
        placeholder="Titlu"
        value={newPress.title || ""}
        onChange={(e) => setNewPress({ ...newPress, title: e.target.value })}
      />
      <textarea
        placeholder="Conținut complet"
        value={newPress.content || ""}
        onChange={(e) => setNewPress({ ...newPress, content: e.target.value })}
      />
      <input
        type="date"
        value={newPress.date || ""}
        onChange={(e) => setNewPress({ ...newPress, date: e.target.value })}
      />
      <label>Imagine comunicat:</label>
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setNewImageFile(e.target.files?.[0] || null)}
      />
      <button onClick={addPressRelease}>Adaugă</button>

      <hr />
      <button className="save-btn" onClick={saveAll}>
        Salvează tot
      </button>
    </div>
  );
};
